import { basicPathND } from '../basicPathND';

export const fetchAssessmentQuestionsAssessmentIdsND = async (params) => {
    const path = '/mp/assessment-questions/assessment-ids';
    const type = 'get';
    return await basicPathND(params, path, type);
}